import React, {useState, useEffect} from 'react';
import { toast } from 'react-toastify';
import { variables } from '../Variables/Variable';

const Aboutus = () => {
    const [name,setName] = useState("");
    const [email, setEmail] = useState("");
    const [message,setMessage] = useState("");
    var emailregx = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    function isValid() {
       
          //Registration
          if ( email == "" || name == "" || message == "" ) {
            toast.error("please fill required fields");
            return false;
          } else if (!emailregx.test(email)){
            toast.error("Bad email format");
          }else {
            return true;
          }
      }
      const handleSubmit = (e) => {
        e.preventDefault();

     if(isValid()){
        fetch(variables.API_URL + "Contact/SendContactEmailAboutus/", {
            method: "POST",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
                "Access-Control-Allow-Origin": variables.API_URL,
            },
            body: JSON.stringify({
                Name: name,
                Email: email,
                Message: message
              }),
        })
            .then((Response) => {
                if (Response.ok) {
                    toast.success("Email sent Sucessfully");
                    setName("");
                    setEmail("");
                    setMessage("");
                    return Response.json();
                }
            })
     }
    }
    useEffect(() => {

    },[name,email,message])

  return (
    <>
       {/* <!-- /.preloader --> */}
    <div className="page-wrapper">

        


        {/* <!--Start Page Header--> */}
        <section className="page-header">
            <div className="page-header__bg" style={{backgroundImage: "url(/assets/images/backgrounds/page-header-img1.jpg)"}}>
            </div>
            <div className="container">
                <div className="row">
                    <div className="col-xl-12">
                        <div className="page-header__wrapper">
                            <div className="page-header__content">
                                <h2>About Company</h2>
                                <div className="page-header__menu">
                                    <ul>
                                        <li><a hreflang="en" href="/">Home</a></li>
                                        <li>About us</li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        {/* <!--End Page Header--> */}



        {/* <!--Start About One--> */}
        <section className="about-one about-one--two about-one--two--about">
            <div className="container">
                <div className="row">
                    {/* <!--Start About One Img Box--> */}
                    <div className="col-xl-6">
                        <div className="about-one__img">
                            <div className="shape1 zoom-fade"><img src="/assets/images/shapes/about-v1-shape1.png" alt="" />
                            </div>
                            <div className="about-one__img1">
                                <img src="/assets/images/about/about-v2-img1.jpg" alt="" />
                            </div>

                            <div className="about-one__img2">
                                <div className="video-icon">
                                    <a className="video-popup wow zoomIn animated animated animated animated"
                                        data-wow-delay="300ms" data-wow-duration="1500ms" title=" Video"
                                        hreflang="en" href="https://www.youtube.com/watch?v=p25gICT63ek"
                                        style={{visibility: "visible", animationDuration: "1500ms", animationDelay: "300ms", animationName: "zoomIn"}}>
                                        <span className="icon-play-button-3"></span>
                                    </a>
                                </div>
                                <img src="/assets/images/about/about-v2-img2.jpg" alt="" />
                            </div>
                        </div>
                    </div>
                    {/* <!--End About One Img Box--> */}



                    {/* <!--Start About One Content--> */}
                    <div className="col-xl-6">
                        <div className="about-one__content">
                            <div className="sec-title">
                                <span className="sec-title__tagline">Why Choose Us</span>
                                <h2 className="sec-title__title">We are a modern <br/>Flooring agency...</h2>
                            </div>

                            <div className="about-two__content-text1">
                                <p>Alori is a full-service Florring company. Our established
                                    systems allow us to deliver industry-leading landscape
                                    solutions to commercial and residential clients. </p>
                            </div>

                            <div className="about-two__content-text2">
                                <p>Dictum fusce ut placerat orci nulla. Amet aliquam cenas
                                    ultricies. Facilisis sed odio morbi quis magnis </p>
                            </div>

                            <ul className="about-one__content-list">
                                <li>
                                    <div className="icon">
                                        <span className="icon-wood-board"></span>
                                    </div>

                                    <div className="title">
                                        <h3>Hardwood Floor Care Center</h3>
                                    </div>
                                </li>

                                <li>
                                    <div className="icon">
                                        <span className="icon-customer-satisfaction-1"></span>
                                    </div>

                                    <div className="title">
                                        <h3>High-Quality Floorings At Great Prices</h3>
                                    </div>
                                </li>

                                <li>
                                    <div className="icon">
                                        <span className="icon-wood"></span>
                                    </div>

                                    <div className="title">
                                        <h3>We solve complex flooring issues</h3>
                                    </div>
                                </li>
                            </ul>

                        </div>
                    </div>
                    {/* <!--End About One Content--> */}
                </div>
            </div>
        </section>
        {/* <!--End About One--> */}




        {/* <!--Start Mission One--> */}
        <section className="mission-one">
            <div className="container">
                <div className="row">
                    {/* <!--Start Mission One Content--> */}
                    <div className="col-xl-6">
                        <div className="mission-one__content">
                            <div className="mission-one__content-single">
                                <h2>Our Mission</h2>
                                <div className="text1">
                                    <p>There are more than 11 million young people in the uk, they make up over a fifth
                                        of the population and represent Britain’s future.</p>
                                </div>

                                <div className="text2">
                                    <p>Tempor auf ullamcorper lacus vestibulum arcu. Posuere lorem ipsum dolorsit
                                        consectetur adipiscing. Sollicitudin tempor id eu nisl nunc ipsum. Odio tempor
                                        orci dapibus ultrices. Quam viverra sagittis
                                        volutpat odio facilisis.</p>
                                </div>
                            </div>


                            <div className="mission-one__content-single marb-0">
                                <h2>Our Vision</h2>
                                <div className="text1">
                                    <p>There are more than 11 million young people in the uk, they make up over a fifth
                                        of the population and represent Britain’s future.</p>
                                </div>

                                <div className="text2">
                                    <p>Tempor auf ullamcorper lacus vestibulum arcu. Posuere lorem ipsum dolorsit
                                        consectetur adipiscing. Sollicitudin tempor id eu nisl nunc ipsum. Odio tempor
                                        orci dapibus ultrices. Quam viverra sagittis
                                        volutpat odio facilisis.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* <!--End Mission One Content--> */}

                    {/* <!--Start Mission One Img--> */}
                    <div className="col-xl-6">
                        <div className="mission-one__img">
                            <div className="shape1"><img src="/assets/images/shapes/mission-v1-shape1.jpg" alt="" /></div>
                            <div className="mission-one__img-img1">
                                <img src="/assets/images/resources/mission-v1-img1.jpg" alt="" />
                            </div>

                            <div className="mission-one__img-img2 wow slideInRight" data-wow-delay="500ms"
                                data-wow-duration="2500ms">
                                <img src="/assets/images/resources/mission-v1-img2.jpg" alt="" />
                            </div>
                        </div>
                    </div>
                    {/* <!--End Mission One Img--> */}
                </div>
            </div>
        </section>
        {/* <!--End Mission One--> */}




        {/* <!--Start Best Logistics One--> */}
        <section className="best-logistics-one">
            <div className="shape2 zoominout"><img src="/assets/images/shapes/best-logistics-v1-shape2.png" alt="" /></div>
            <div className="container">
                <div className="row">
                    {/* <!--Start Best Logistics One Content--> */}
                    <div className="col-xl-6">
                        <div className="best-logistics-one__content">
                            <div className="sec-title">
                                <h2 className="sec-title__title">Expert Flooring <br/>Installers</h2>
                                <p className="sec-title__text">There are many variations of passages of Lorem Ipsum
                                    available but the majority have suffered alteration </p>
                            </div>

                            <ul className="best-logistics-one__content-counter">
                                <li className="wow fadeInUp" data-wow-delay="0ms" data-wow-duration="1500ms">
                                    <div className="inner">
                                        <h2>
                                            <span className="odometer" data-count="5">00</span><span className="k">k</span><span
                                                className="fa fa-plus plus-icon"></span>
                                        </h2>
                                        <h3 className="best-logistics-one__content-counter-title">Completed Projects</h3>
                                        <p className="best-logistics-one__content-counter-text">5k complete work</p>
                                    </div>
                                </li>

                                <li className="wow fadeInUp" data-wow-delay="200ms" data-wow-duration="1500ms">
                                    <h2>
                                        <span className="odometer" data-count="30">00</span><span
                                            className="fa fa-plus plus-icon pd-l"></span>
                                    </h2>
                                    <h3 className="best-logistics-one__content-counter-title">Our Expert </h3>
                                    <p className="best-logistics-one__content-counter-text">Expert Flooring worker</p>
                                </li>

                            </ul>


                            <div className="best-logistics-one__content-bottom">
                                <div className="best-logistics-one__content-bottom-text">
                                    <p>We can help you stand out your business</p>
                                </div>

                                <div className="best-logistics-one__content-bottom-btn">
                                    <a hreflang="en" href="#" className="thm-btn">Learn More</a>
                                </div>
                            </div>


                        </div>
                    </div>
                    {/* <!--End Best Logistics One Content--> */}

                    {/* <!--Start Best Logistics One Img--> */}
                    <div className="col-xl-6">
                        <div className="best-logistics-one__img">
                            <div className="shape1 zoom-fade"><img src="/assets/images/shapes/best-logistics-v1-shape1.png"
                                    alt="" /></div>

                            <div className="shape3"><img src="/assets/images/shapes/best-logistics-v1-shape2.png" alt="" />
                            </div>
                            <div className="best-logistics-one__img-inner">
                                <img src="/assets/images/resources/best-logistics-v1-img.jpg" alt="" />
                            </div>
                            <div className="overlay-content">
                                <h2>We Are Since 2006 ! Over 200 Awards</h2>
                            </div>
                        </div>
                    </div>
                    {/* <!--End Best Logistics One Img--> */}
                </div>
            </div>
        </section>
        {/* <!--End Best Logistics One--> */}


        {/* <!--Start Video One--> */}
        <section className="video-one video-one--two video-one--two--about wow slideInUp" data-wow-delay="100ms"
            data-wow-duration="1500ms">
            <div className="container">
                <div className="row">
                    <div className="col-xl-12">
                        <div className="video-one__inner text-center"
                            style={{backgroundImage: "url(/assets/images/backgrounds/video-v1-bg.jpg)"}}>
                            <div className="shape1"><img src="/assets/images/shapes/video-v1-shape1.png" alt="" /></div>
                            <h2>A Complete Solution for Your Flooring <br/>Vision.We have done more than 562 <br/>
                                successful projects</h2>
                            <p>Schedule a free case evaluation. Or call us at +88 17 12 48101</p>

                            <div className="video-one__bottom">
                                <div className="text">
                                    <a hreflang="en" href="/Portfolio">View all Project</a>
                                </div>
                                <div className="icon">
                                    <a hreflang="en" href="https://www.youtube.com/watch?v=8DP4NgupAhI"
                                        className="video-one__btn video-popup">
                                        <span className="icon-play-2"></span>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        {/* <!--End Video One--> */}





        {/* <!--Start Team One--> */}
        <section className="team-one">
            <div className="container">
                <div className="sec-title text-center">
                    <span className=" sec-title__tagline">Our Team</span>
                    <h2 className="sec-title__title">Our talent Florring Team</h2>
                </div>
                <div className="row">
                    {/* <!--Start Single Team One--> */}
                    <div className="col-xl-4 col-lg-4 wow fadeInLeft" data-wow-delay="0ms" data-wow-duration="1500ms">
                        <div className="team-one__single">
                            <div className="team-one__single-img">
                                <img src="/assets/images/team/team-v1-img1.jpg" alt="" />
                                <div className="overlay-icon">
                                    <ul>
                                        <li><a hreflang="en" href="#"><span className="fab fa-facebook"></span></a></li>
                                        <li><a hreflang="en" href="#"><span className="fab fa-instagram"></span></a></li>
                                        <li><a hreflang="en" href="#"><span className="fab fa-linkedin"></span></a></li>
                                        <li><a hreflang="en" href="#"><span className="fab fa-twitter"></span></a></li>
                                    </ul>
                                </div>
                            </div>

                            <div className="team-one__single-content text-center">
                                <h2><a hreflang="en" href="/Team">Mahfuz Riad </a></h2>
                                <p>Wood Installer</p>
                            </div>
                        </div>
                    </div>
                    {/* <!--End Single Team One--> */}

                    {/* <!--Start Single Team One--> */}
                    <div className="col-xl-4 col-lg-4 wow fadeInLeft" data-wow-delay="200ms" data-wow-duration="1500ms">
                        <div className="team-one__single">
                            <div className="team-one__single-img">
                                <img src="/assets/images/team/team-v1-img2.jpg" alt="" />
                                <div className="overlay-icon">
                                    <ul>
                                        <li><a hreflang="en" href="#"><span className="fab fa-facebook"></span></a></li>
                                        <li><a hreflang="en" href="#"><span className="fab fa-instagram"></span></a></li>
                                        <li><a hreflang="en" href="#"><span className="fab fa-linkedin"></span></a></li>
                                        <li><a hreflang="en" href="#"><span className="fab fa-twitter"></span></a></li>
                                    </ul>
                                </div>
                            </div>

                            <div className="team-one__single-content text-center">
                                <h2><a hreflang="en" href="/Team">Max Chaoma</a></h2>
                                <p>Floor Carpet Installer</p>
                            </div>
                        </div>
                    </div>
                    {/* <!--End Single Team One--> */}

                    {/* <!--Start Single Team One--> */}
                    <div className="col-xl-4 col-lg-4 wow fadeInLeft" data-wow-delay="400ms" data-wow-duration="1500ms">
                        <div className="team-one__single">
                            <div className="team-one__single-img">
                                <img src="/assets/images/team/team-v1-img3.jpg" alt="" />
                                <div className="overlay-icon">
                                    <ul>
                                        <li><a hreflang="en" href="#"><span className="fab fa-facebook"></span></a></li>
                                        <li><a hreflang="en" href="#"><span className="fab fa-instagram"></span></a></li>
                                        <li><a hreflang="en" href="#"><span className="fab fa-linkedin"></span></a></li>
                                        <li><a hreflang="en" href="#"><span className="fab fa-twitter"></span></a></li>
                                    </ul>
                                </div>
                            </div>

                            <div className="team-one__single-content text-center">
                                <h2><a hreflang="en" href="/Team">Foqrul Islam</a></h2>
                                <p>Wood Installer</p>
                            </div>
                        </div>
                    </div>
                    {/* <!--End Single Team One--> */}
                </div>
            </div>
        </section>
        {/* <!--End Team One--> */}



        {/* <!--Start Contact One--> */}
        <section className="contact-one contact-one--two">
            <div className="shape1"><img src="/assets/images/shapes/contact-v1-shape1.png" alt="" /></div>
            <div className="contact-one__img" style={{backgroundImage: "url(/assets/images/resources/contact-v1-img1.jpg)"}}>
                {/* <div className="overlay-content text-center">
                    <h2>25</h2>
                    <h3>Years of <br/>Expeirence</h3>
                </div> */}
            </div>
            <div className="container">
                <div className="row">
                    {/* <!--Start Contact One Img--> */}
                    <div className="col-xl-6 col-lg-0">

                    </div>
                    {/* <!--End Contact One Img--> */}

                    {/* <!--Start Contact One Content--> */}
                    <div className="col-xl-6 col-lg-12">
                        <div className="contact-one__content">
                            <div className="sec-title">
                                <span className="sec-title__tagline">Contact us</span>
                                <h2 className="sec-title__title">Lets Create Something <br/>Great Together!</h2>
                            </div>

                            <div className="contact-one__content-comment-form">
                            {/* action="/assets/inc/sendemail.php" className="comment-one__form contact-form-validated" */}
                            {/* novalidate="novalidate" */}
                                <form onSubmit={handleSubmit}>
                                    <div className="row">
                                        <div className="col-xl-6 col-lg-6 col-md-6">
                                            <div className="comment-form__input-box">
                                                <input type="text" placeholder="Full Name" name="name" onChange={(e) => setName(e.target.value)}/>
                                            </div>
                                        </div>
                                        <div className="col-xl-6 col-lg-6 col-md-6">
                                            <div className="comment-form__input-box">
                                                <input type="email" placeholder="Email Addresss" name="email" onChange={(e) => setEmail(e.target.value)}/>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="row">
                                        <div className="col-xl-12 col-lg-12">
                                            <div className="comment-form__input-box">
                                                <textarea name="message" placeholder="Message Details" onChange={(e) => setMessage(e.target.value)}></textarea>
                                            </div>
                                            <button type="submit" className="thm-btn comment-form__btn">Send</button>
                                        </div>
                                    </div>
                                </form>
                            </div>

                        </div>
                    </div>
                    {/* <!--End Contact One Content--> */}
                </div>
            </div>
        </section>
        {/* <!--End Contact One--> */}


    </div>
    {/* <!-- /.page-wrapper --> */}


    </>
  )
}

export default Aboutus